import { Reveal } from "@/components/Reveal";
import QuoteEstimator from "@/components/QuoteEstimator";

export default function Quote() {
  return (
    <div data-testid="quote-page">
      <section className="relative overflow-hidden pt-32 pb-12 lg:pt-40">
        <div className="absolute inset-0 hero-grid opacity-60" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(0,102,255,0.15),transparent_60%)]" />
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <Reveal>
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-cyan-400">Get a quote</p>
            <h1 className="mt-4 max-w-3xl font-display text-4xl font-extrabold leading-[1.08] tracking-tight text-white sm:text-5xl" data-testid="quote-page-title">
              Scope your project in <span className="text-gradient">under two minutes</span>
            </h1>
            <p className="mt-5 max-w-2xl text-sm leading-relaxed text-slate-400 sm:text-base">
              Tell us what you need in four quick steps, then send it through — our team will
              come back with a tailored, fixed-price quote, free of charge.
            </p>
          </Reveal>
        </div>
      </section>
      <section className="mx-auto max-w-7xl px-4 pb-24 sm:px-6 lg:px-8">
        <QuoteEstimator />
      </section>
    </div>
  );
}
